import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { Button } from '@/components/ui/Button';
import { ListItem } from '@/components/ui/ListItem';
import { Spinner } from '@/components/ui/Spinner';
import { useDeleteFamilyMember, useFamily } from '@/api/queries/family';
import { paths } from '@/routes/paths';
import { IcEdit, IcTrash } from '@/components/ui/icons';

export function SettingsFamilyEditPage(): JSX.Element {
  const { t } = useTranslation();
  const family = useFamily();
  const del = useDeleteFamilyMember();
  const navigate = useNavigate();

  return (
    <AppShell>
      <PageContainer>
        <TopBar back title={t('settings.family')} />
        {family.isLoading && <Spinner />}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {family.data?.map((m) => (
            <ListItem
              key={m.id}
              title={`${m.given_name} ${m.surname}`}
              subtitle={t(`family_member.role.${m.role}`)}
              trailing={
                <div style={{ display: 'flex', gap: 8 }}>
                  <button style={{ color: 'var(--color-accent-blue)' }} aria-label="Edit"><IcEdit /></button>
                  <button style={{ color: 'var(--color-danger)' }} aria-label="Delete" onClick={() => del.mutate(m.id)}>
                    <IcTrash />
                  </button>
                </div>
              }
            />
          ))}
        </div>
        <Button block variant="inverted" onClick={() => navigate(paths.onboardingFamilyForm)}>
          + {t('onboarding.family.add')}
        </Button>
      </PageContainer>
    </AppShell>
  );
}
